import { render, staticRenderFns } from "./profileFriendsTab.vue?vue&type=template&id=27d56386&scoped=true&"
import script from "./profileFriendsTab.vue?vue&type=script&lang=js&"
export * from "./profileFriendsTab.vue?vue&type=script&lang=js&"
import style0 from "./profileFriendsTab.vue?vue&type=style&index=0&id=27d56386&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d56386",
  null
  
)

export default component.exports